import { getMapChromeTheme } from "@/components/mapChromeTheme";

type CatalogKind = "folder" | "tile-set" | "collection";

export function FolderGlyph({ className = "h-3 w-3 shrink-0" }: { className?: string } = {}) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1.75 4.75a1.5 1.5 0 0 1 1.5-1.5H6l1.25 1.5h5.5a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-9.5a1.5 1.5 0 0 1-1.5-1.5z" />
    </svg>
  );
}

export function CatalogKindBadge({
  kind,
  className = "",
}: {
  kind: CatalogKind;
  className?: string;
}) {
  const theme = getMapChromeTheme();
  const label = kind === "tile-set" ? "Tile Set" : kind === "collection" ? "Collection" : "Folder";

  return (
    <span className={`${theme.cardBadge} inline-flex items-center gap-1.5 ${className}`.trim()}>
      {kind === "folder" ? <FolderGlyph /> : null}
      <span>{label}</span>
    </span>
  );
}
